import request from '@/request'

// 获取banner
export const getlist = data => {
  return request({
    url: '/inf_PuhuiPic_Vipwd/getList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

// 获取图标列表
export const geticonlist = data => {
  return request({
    url: '/mobile_Banner_Vipwd/iconList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

// 获取店铺标题图列表
export const getshoplist = data => {
  return request({
    url: '/mobile_Banner_Vipwd/shopList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

// 新增记录
export const getaddlog = data => {
  return request({
    url: '/mobile_Page_Vipwd/addClickLog.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
